export default "__VITE_ASSET__BBeJEdXm__"